/**
 * FAQ: smooth open and close of the native <details> (render.php). Without this script, or with reduced motion,
 * the browser opens and closes them at once. While closing, `is-closing` is on the <details> so the icon turns
 * back at the click (the `open` attribute stays until the answer has slid up).
 */
const DURATION = 300; // --duration-base
const EASING = 'ease-in-out';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function init(item: HTMLDetailsElement): void {
	const summary = item.querySelector<HTMLElement>(':scope > summary');
	const answer = item.querySelector<HTMLElement>(':scope > [data-faq-answer]');
	if (!summary || !answer) return;

	let animation: Animation | null = null;

	const finish = (open: boolean): void => {
		animation = null;
		item.classList.remove('is-closing');
		item.open = open;
		answer.style.height = '';
	};

	summary.addEventListener('click', (event) => {
		if (reducedMotion.matches || typeof answer.animate !== 'function') return; // native toggle
		event.preventDefault();

		const closing = item.open && !item.classList.contains('is-closing');
		// A closed <details> may still report its answer's height (Chrome lays out hidden content): start from 0
		const from = item.open ? `${answer.offsetHeight}px` : '0px';
		animation?.cancel();

		if (closing) {
			item.classList.add('is-closing');
			animation = answer.animate({ height: [from, '0px'] }, { duration: DURATION, easing: EASING });
			animation.onfinish = () => finish(false);
		} else {
			item.classList.remove('is-closing');
			item.open = true;
			const to = `${answer.scrollHeight}px`;
			animation = answer.animate({ height: [from, to] }, { duration: DURATION, easing: EASING });
			animation.onfinish = () => finish(true);
		}
	});
}

function initAll(): void {
	document.querySelectorAll<HTMLDetailsElement>('[data-px-block="faq"] details[data-faq-item]').forEach(init);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAll);
} else {
	initAll();
}
